import { ref, onValue } from "firebase/database";
import { FirebaseContext } from "../../firebase/firebase";
import { useContext, useEffect, useState } from "react";

const useFirebase = () => {
  const firebase = useContext<any>(FirebaseContext);
  const [dataFirebase, setDataFirebase] = useState<any>([]);
  useEffect(() => {
    if (!firebase) return;
    const fetchData = async () => {
      const dataRef = ref(firebase, `/site/thaihealth/outdoor_weather`);
      onValue(dataRef, (snapshot: any) => {
        const val = snapshot.val();
        setDataFirebase(val);
      });
    };
    fetchData();
  }, [firebase]);

  return { dataFirebase };
};

export default useFirebase;
